// ============================================
// MAIN APP - Shrileela Beach Resort
// ============================================

import { useState } from 'react';
import SpecialOfferBanner from "./SpecialOfferBanner";
import Navbar from "./Navbar";
import Hero from "./Hero";
import AmenitiesSection from "./AmenitiesSection";
import RoomsSection from "./RoomsSection";
import DiningSection from "./DiningSection";
import EventsSection from "./EventsSection";
import GallerySection from "./GallerySection";
import TestimonialsSection from "./TestimonialsSection";
import BookingSection from "./BookingSection";
import ContactSection from "./ContactSection";
import Footer from "./Footer";
import FloatingBookButton from "./FloatingBookButton";
import { Toaster } from "./ui/sonner";

function ShreeApp() {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);

  // Called from Navbar / FloatingBookButton — no pre-selected room
  const openBookingModal = () => {
    setSelectedRoom(null);
    setIsBookingModalOpen(true);
  };

  // Called from RoomsSection card button — pre-selects that room
  const handleBookRoom = (room) => {
    setSelectedRoom(room);
    setIsBookingModalOpen(true);
  };

  const closeBookingModal = () => {
    setIsBookingModalOpen(false);
  };

  return (
    <div className="App">
      {/* <SpecialOfferBanner /> */}

      <Navbar onBookNow={openBookingModal} />

      <Hero onBookNow={openBookingModal}  />
      {/* <AmenitiesSection /> */}

      {/* ✅ Pass handleBookRoom so "Book This Room" pre-selects the card */}
      <RoomsSection onBookRoom={handleBookRoom} />

      <DiningSection />
      {/* <EventsSection /> */}
      <GallerySection />
      {/* <TestimonialsSection /> */}

      <ContactSection />
      <Footer />

      {/* <FloatingBookButton onBookNow={openBookingModal} /> */}

      {/* ✅ Single BookingSection modal — receives selectedRoom to pre-fill */}
      <BookingSection
        isOpen={isBookingModalOpen}
        onClose={closeBookingModal}
        selectedRoom={selectedRoom}
      />

      <Toaster />
    </div>
  );
}

export default ShreeApp;